import { useContext } from 'react';

import Button from '@/components/common/Button';
import { UserIdentity } from '@/components/RightProvider/const';
import { RightContext } from '@/components/RightProvider/context';
import { UseTranslateType } from '@/hooks/useTranslate';
import { CurrentVip, VIPSOURCE } from '@/store/User';
import { VIPWEIGHT } from '@/store/User/const';
import { isCnArea } from '@/utils/envHelper';

import { TabContentProps } from '..';

// 用于disable按钮的优先级
const dateVipMap = {
  freeVip_twoweek: 0,
  freeVip_month: 0,
  freeVip_year: 1,

  basicVip_twoweek: 1.5,
  basicVip_month: 2,
  basicVip_year: 3,

  advancedVip_twoweek: 3.5,
  advancedVip_month: 4,
  advancedVip_year: 5,

  enterpriseVip_twoweek: 5.5,
  enterpriseVip_month: 6,
  enterpriseVip_year: 7,
};

const BuyBtn = ({
  type,
  weight,
  activeDateType,
  loading,
  onClick,
  t,
}: {
  type: UserIdentity;
  weight: number;
  activeDateType: Extract<TabContentProps['activeKey'], 'year' | 'month' | 'twoweek'>;
  loading: boolean;
  onClick: () => void;
  t: UseTranslateType;
}) => {
  const { currentVip } = useContext(RightContext);
  const { title: userTitle, key: userType, weight: userWeight, vipSource } = currentVip;
  const showText = () => {
    if (weight === VIPWEIGHT.enterpriseVip) {
      return t('merror.sub.contact');
    }
    if (userTitle === 'enterpriseVip') {
      return t('merror.sub.try');
    }
    if (userWeight === VIPWEIGHT.freeVip && weight === userWeight) {
      return t('merror.sub.current');
    }
    if (vipSource !== VIPSOURCE.Purchase) {
      // vcm配置的或者兑换码兑换的
      return type === 'freeVip' ? t('merror.sub.current') : t('merror.sub.try');
    }

    if (userWeight === weight) {
      if (userTitle === 'year' || userTitle === 'month' || userTitle === 'twoweek') {
        if (userTitle === activeDateType) {
          return t('merror.sub.current');
        } else {
          return t('merror.sub.try');
        }
      } else {
        if (activeDateType === 'month') {
          return t('merror.sub.current');
        } else {
          return t('merror.sub.try');
        }
      }
    }
    return t('merror.sub.try');
  };
  const handleDisbled = () => {
    if (userWeight === VIPWEIGHT.enterpriseVip) {
      return weight === VIPWEIGHT.enterpriseVip ? false : true;
    }
    if (userType === 'freeVip' && weight === VIPWEIGHT.freeVip) {
      return true;
    }
    if (vipSource !== VIPSOURCE.Purchase) {
      // vcm配置的或者兑换码兑换的
      return type === 'freeVip' ? true : false;
    }

    if (userTitle === 'year' || userTitle === 'month' || userTitle === 'twoweek') {
      let userData = dateVipMap[`${userType}_${userTitle}`];
      let currentData = dateVipMap[`${type}_${activeDateType}`];
      if (isCnArea) {
        return userData > currentData ? true : false;
      } else {
        return userData >= currentData ? true : false;
      }
    } else {
      if (weight > userWeight) {
        return false;
      } else if (weight < userWeight) {
        return true;
      } else {
        if (weight === userWeight) {
          if (activeDateType === 'month') {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
    }
  };
  const text = showText();
  let disabled = handleDisbled();

  let style = {};
  if (type === 'enterpriseVip') {
    return (
      <div
        style={{
          width: '100%',
          display: 'inline-block',
          borderRadius: 12,
          padding: 2,
          background: 'linear-gradient(90deg, #4D2FFF, #EF5CFF)',
          boxSizing: 'border-box',
          cursor: 'pointer',
        }}
        onClick={onClick}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            borderRadius: 10,
            background: '#ffffff',
            padding: '6px 14px',
            display: 'inline-block',
            fontWeight: 600,
            fontSize: 16,
          }}
        >
          <span
            style={{
              backgroundImage: 'linear-gradient(90deg, #4D2FFF, #EF5CFF)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              color: 'transparent',
            }}
          >
            {text}
          </span>
        </div>
      </div>
    );
  } else if (disabled) {
    style = {
      background: 'var(--common-button-bg-disabled-color)',
    };
  } else {
    style = {
      background: 'linear-gradient(90deg, #4D2FFF 0%, #EF5CFF 100%)',
    };
  }

  return (
    <Button
      className="!w-full !py-[8px] !px-[16px]"
      style={style}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default BuyBtn;
